import areaSelector from './area-selector'
export default areaSelector
